import { createAsyncThunk } from '@reduxjs/toolkit';
import { _userUrls } from '@custom/Utils/constants/apiUrls';

const deactivateRadiologistUserApi = createAsyncThunk('deactivateRadiologistUserApi', async () => {
    const pageLimit = 30;
    const pageNumber = 1;
    const offset = pageLimit * (pageNumber - 1);
    const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    try {
        let url = `${_userUrls.deactiveRadiologistUser}?limit=${pageLimit}&offset=${offset}&search=&hospitalId=${hospitalId}&from=teraradiology`;
        let response = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
            }
        })
        return await response.json()
    } catch (error) {
        return error;
    }
});

export default deactivateRadiologistUserApi;
